/**
 * ChartMind-I2 access subscription — chartMindI2Access/{uid}.
 */
import { db } from "services/firebase";
import { CHART_MIND_I2_ACCESS_COLLECTION } from "../chartMindI2Constants";

export function subscribeToChartMindI2Access(uid, onData, onError) {
  if (!uid) {
    onData(null);
    return () => {};
  }
  return db
    .collection(CHART_MIND_I2_ACCESS_COLLECTION)
    .doc(uid)
    .onSnapshot(
      (snap) => {
        onData(snap.exists ? snap.data() : null);
      },
      (err) => {
        console.warn("[chartMindI2Access] subscription failed", err?.code || err?.message || err);
        if (typeof onError === "function") onError(err);
      },
    );
}
